module.exports = __webpack_public_path__ + "img/file.a0d02d24.svg";